import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

export default function ETAIndicator({ district }) {
  const [eta, setEta] = useState(null);

  useEffect(() => {
    // Dinamik ETA - gerçek zamanlı his veren hesaplama
    const hour = new Date().getHours();
    let base;
    if (hour >= 7 && hour <= 9) base = 25;       // sabah rush
    else if (hour >= 17 && hour <= 19) base = 30; // akşam rush
    else if (hour >= 23 || hour <= 5) base = 15;  // gece — boş yollar
    else base = 20;                                // normal

    // İlçeye göre ± 5 dk varyasyon (deterministic)
    const districtHash = (district || '').split('').reduce((a, c) => a + c.charCodeAt(0), 0);
    const variation = (districtHash % 10) - 5;
    setEta(Math.max(10, base + variation));
  }, [district]);

  if (!eta) return null;

  return (
    <div
      data-testid="eta-indicator"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '.5rem',
        background: 'rgba(52,199,89,.06)',
        border: '1px solid rgba(52,199,89,.2)',
        borderRadius: 'var(--r)',
        padding: '.625rem 1rem',
        marginTop: '.75rem',
      }}
    >
      <div style={{
        width: 32, height: 32, borderRadius: 8,
        background: 'rgba(52,199,89,.12)', border: '1px solid rgba(52,199,89,.2)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Clock size={15} style={{ color: 'var(--green)' }} />
      </div>
      <div>
        <div style={{
          fontFamily: "'Space Grotesk',sans-serif",
          fontWeight: 800, fontSize: '1rem', color: 'var(--green)', lineHeight: 1,
        }}>
          ~{eta} dakika
        </div>
        <div style={{ fontSize: '.68rem', color: 'var(--text2)', marginTop: '.1rem' }}>
          Tahmini varış süresi
        </div>
      </div>
    </div>
  );
}
